import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";

import NoNavbar from "../layouts/NoNavbar.vue";
import WithNavbar from "../layouts/WithNavbar.vue";
import PatientDetailsList from "../layouts/PatientDetailsList.vue";
import AddPatientFormSign from "@/views/Patients/forms/EditPatientFormSign.vue";
import EditPatientFormSign from "@/views/Patients/forms/EditPatientFormSign.vue";
import FormSignView from "@/views/Settings/formSign/FormSignView.vue";
import AddFormSign from "@/views/Settings/formSign/AddFormSign.vue";
import EditFormSign from "@/views/Settings/formSign/EditFormSign.vue";
import EditPatientFormSignWithoutSidbar from "@/views/Patients/forms/EditPatientFormSignWithoutSidbar.vue";
import AddPatientDepartmentNote from "@/views/Patients/departmentNote/AddPatientDepartmentNote.vue";
import ListDepartmentNoteView from "@/views/Patients/departmentNote/ListDepartmentNoteView.vue";
import EditPatientDepartmentNote from "@/views/Patients/departmentNote/EditPatientDepartmentNote.vue";
import ProgramView from "@/views/Settings/Program/ProgramView.vue";
import EditProgram from "@/views/Settings/Program/EditProgram.vue";
import AddProgram from "@/views/Settings/Program/AddProgram.vue";
import Test from "@/views/Settings/communication/Test.vue";
import AddUnavailableBlock from "@/views/Settings/UnavailableBlockType/AddUnavailableBlock.vue";
import EditUnavailableBlock from "@/views/Settings/UnavailableBlockType/EditUnavailableBlock.vue";
import UnavailableBlockTypeView from "@/views/Settings/UnavailableBlockType/UnavailableBlockTypeView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/view/patients/:id/form-signatures/:patientFormSignId/edit",
    component: EditPatientFormSignWithoutSidbar,
    name: "formSignaturesNewTap",
  },
  {
    path: "/",

    component: WithNavbar,
    children: [
      {
        path: "/",
        name: "DashboardView",
        component: () => import("../views/DashboardView.vue"),
        meta: { breadcrumb: "Dashboard", title: "Dashboard" },
      },
      {
        path: "/test",
        name: "test",
        component: Test,
      },
      {
        path: "/appointements",
        name: "AppointementsView",
        component: () => import("../views/AppointementsView.vue"),
        meta: { breadcrumb: "Appointements", title: "Appointments" },
      },
      {
        path: "/statistics",
        name: "StatisticsView",
        component: () => import("../views/StatisticsView.vue"),
        meta: { breadcrumb: "Statistics", title: "Statistics" },
      },
      {
        path: "/conversations",
        name: "Conversations",
        component: () => import("@/views/Conversation/ConversationView.vue"),
        meta: { breadcrumb: "Messages", title: "Messages" },
      },
      {
        path: "/patients",
        name: "PatientView",
        component: () => import("@/views/Patients/PatientView.vue"),
        meta: { breadcrumb: "Patients", title: "Patients" },
      },
      {
        path: "/patients/new",
        name: "AddPatient",
        component: () => import("@/views/Patients/AddPatient"),
        meta: { breadcrumb: "New Patient" },
      },
      {
        path: "/patients/:id/edit",
        name: "EditPatient",
        component: () => import("@/views/Patients/EditPatient.vue"),
        meta: { breadcrumb: "Edit Patient" },
      },
      {
        path: "/patients/:id/patient_history",
        name: "PatientHistory",
        component: () => import("@/views/Patients/PatientHistory.vue"),
        meta: { breadcrumb: "Patient History" },
      },
      {
        path: "/reports/appointments-schedule",
        name: "AppointmentSchedule",
        component: () =>
          import("@/views/Report/Appointments/AppointmentScheduleReport.vue"),
        meta: { breadcrumb: "Appointment Schedule" },
      },
      {
        path: "/reports/missed-appointments",
        name: "MissedAppointment",
        component: () =>
          import("@/views/Report/Appointments/MissAppointmentReport.vue"),
        meta: { breadcrumb: "Missed Appointment" },
      },
      {
        path: "/reports/treatment-note-completion",
        name: "TreatmentNoteCompletion",
        component: () =>
          import(
            "@/views/Report/Appointments/TreatmentNoteCompletionReport.vue"
          ),
        meta: { breadcrumb: "Treatment Note Completion" },
      },

      {
        path: "/reports",
        name: "ShowReport",
        component: () => import("@/views/ReportsView.vue"),
        meta: { breadcrumb: "Reports" },
      },

      {
        path: "/settings/roles/:id/edit",
        name: "EditRole",
        component: () => import("@/views/Settings/Roles/EditRole.vue"),
        meta: { breadcrumb: "Edit Role" },
      },
      {
        path: "/settings/message-templates/create",
        name: "AddNewMessageTemplate",
        component: () =>
          import("@/views/Settings/communication/AddMessageTemplateView.vue"),
        meta: { breadcrumb: "Message Templates" },
      },
      {
        path: "/settings/message-templates/:id",
        name: "EditMessageTemplate",
        component: () =>
          import("@/views/Settings/communication/EditMessageTemplateView.vue"),
        meta: { breadcrumb: "Message Templates" },
      },
      {
        path: "/settings/message-templates",
        name: "MessageTemplatesIndex",
        component: () =>
          import("@/views/Settings/communication/ViewMessageTemplateView.vue"),
        meta: { breadcrumb: "Message Templates" },
      },
      {
        path: "/settings/message-delivery",
        name: "MessageDeliveryIndex",
        component: () =>
          import("@/views/Settings/communication/MessageDeliveryView.vue"),
        meta: { breadcrumb: "Message Delivery" },
      },
      {
        path: "/settings/roles",
        name: "ViewRoles",
        component: () => import("@/views/Settings/Roles/RolesView.vue"),
        meta: { breadcrumb: "Roles" },
      },
      {
        path: "/settings/roles/new",
        name: "AddRole",
        component: () => import("@/views/Settings/Roles/AddRole.vue"),
        meta: { breadcrumb: "Add Role" },
      },
      {
        path: "/setting/my-profile",
        name: "EditCurrentUserProfile",
        component: () =>
          import("@/views/Settings/Users/EditCurrentUserProfile.vue"),
        meta: { breadcrumb: "Edit Current User Profile" },
      },
      {
        path: "/patients/:id",
        name: "PatientDetails",
        component: PatientDetailsList,
        props: true,
        // meta: {breadcrumb: 'Patient details'},
        children: [
          {
            path: "appointments",
            name: "PatientAppointments",
            component: () => import("@/views/Patients/PatientAppointments.vue"),
            meta: { breadcrumb: "Patient Appointment" },
          },
          {
            path: "files",
            name: "Files",
            component: () => import("@/views/Patients/FilesView.vue"),
            meta: { breadcrumb: "Files" },
          },
          {
            path: "files/private",
            name: "PrivateFiles",
            component: () => import("@/views/Patients/FilesView.vue"),
            props: { privateMode: true },
            meta: {
              breadcrumb: "Private Files",
              requiredPermissions: ["patient_files", "patient_private_files"],
            },
          },
          {
            path: "media",
            name: "Media",
            component: () => import("@/views/Patients/MediaView.vue"),
            meta: { breadcrumb: "Child Progress & Media" },
          },
          {
            path: "form-signatures",
            name: "formSignatures",
            component: () =>
              import("@/views/Patients/forms/FormSignaturesView.vue"),
            meta: { breadcrumb: "Form Signatures" },
          },
          {
            path: "departments",
            name: "departmentNotes",
            component: () =>
              import("@/views/Patients/departmentNote/Departments.vue"),
            meta: { breadcrumb: "Department Notes" },
          },
          {
            path: "form-signatures/:patientFormSignId/edit",
            name: "formSignaturesCreate",
            component: EditPatientFormSign,
          },
          {
            path: "departments/:departmentId/department-notes",
            name: "patientDepartmentNotesCreate",
            component: ListDepartmentNoteView,
          },
          {
            path: "departments/:departmentId/department-notes/create",
            name: "patientDepartmentNotesCreate",
            component: AddPatientDepartmentNote,
          },
          {
            path: "departments/:departmentId/department-notes/:departmentNoteId/patient-department-notes/:patientDepartmentNoteId/view",
            name: "patientDepartmentNotesView",
          },
          {
            path: "departments/:departmentId/department-notes/:departmentNoteId/patient-department-notes/:patientDepartmentNoteId/edit",
            name: "patientDepartmentNotesEdit",
            component: EditPatientDepartmentNote,
          },
          {
            path: "",
            component: () => import("@/views/Patients/PatientDetails"),
            meta: { breadcrumb: "Patient Details" },
          },
          {
            path: "treatment-notes",
            name: "treatmentNotes",
            component: () =>
              import(
                "@/views/Patients/treatmentNote/ListTreatmentNoteView.vue"
              ),
            meta: { breadcrumb: "Patient Treatment Notes" },
          },
          {
            path: "public-treatment-notes",
            name: "publicTreatmentNotes",
            component: () =>
              import(
                "@/views/Patients/treatmentNote/PublicTreatmentNotesView.vue"
              ),
            meta: { breadcrumb: "Public Treatment Notes" },
          },
          {
            path: "archived-treatment-notes",
            name: "archivedTreatmentNotes",
            component: () =>
              import(
                "@/views/Patients/treatmentNote/ArchivedTreatmentNoteView.vue"
              ),
            meta: { breadcrumb: "Archive Treatment Note" },
          },
          {
            path: "treatment-notes/create",
            name: "patientTreatmentNotesCreate",
            component: () =>
              import(
                "@/views/Patients/treatmentNote/AddPatientTreatmentNote.vue"
              ),
          },
          {
            path: "treatment-notes/:patientTreatmentNoteId/edit",
            name: "patientTreatmentNotesEdit",
            component: () =>
              import(
                "@/views/Patients/treatmentNote/EditPatientTreatmentNote.vue"
              ),
          },
          {
            path: "packages",
            name: "patientPackages",
            component: () =>
              import("@/views/Patients/packages/PatientPackagesView.vue"),
            meta: { breadcrumb: "Patient Packages" },
          },
          {
            path: "reports",
            name: "patientReports",
            component: () =>
              import("@/views/Patients/reports/PatientReportsView.vue"),
            meta: { breadcrumb: "Patient Reports" },
          },
          {
            path: "reports/:reportId",
            name: "patientReportItems",
            component: () =>
              import("@/views/Patients/reports/PatientReportItemsView.vue"),
            meta: { breadcrumb: "Report Items" },
          },
          {
            path: "policies",
            name: "PatientPolicies",
            component: () => import("@/views/Patients/PatientPoliciesView.vue"),
            meta: { breadcrumb: "Patient Policies" },
          },
        ],
      },
      {
        path: "/settings",
        name: "SettingsView",
        component: () => import("../views/SettingsView.vue"),
        meta: { breadcrumb: "Settings" },
      },
      {
        path: "/settings/department-note",
        name: "SettingsView",
        component: () =>
          import("../views/Settings/DepartmentNote/DepartmentNoteView.vue"),
        meta: { breadcrumb: "Department Note" },
      },
      {
        path: "/settings/departments/:departmentId/department-notes",
        name: "ShowDepartmentNoteForDepartment",
        component: () =>
          import(
            "../views/Settings/DepartmentNote/DepartmentNoteInDepartmentView.vue"
          ),
      },
      {
        path: "/settings/departments/:departmentId/department-notes/create",
        name: "SettingsView",
        component: () =>
          import("../views/Settings/DepartmentNote/AddDepartmentNote.vue"),
        meta: { breadcrumb: "Settings" },
      },
      {
        path: "/settings/departments/:departmentId/department-notes/:departmentNoteId/edit",
        name: "SettingsView",
        component: () =>
          import("../views/Settings/DepartmentNote/EditDepartmentNote.vue"),
        meta: { breadcrumb: "Settings" },
      },
      {
        path: "/settings/treatment-notes",
        name: "TreatmentNoteView",
        component: () =>
          import(
            "../views/Settings/TreatmentNote/TreatmentNoteInDepartmentView.vue"
          ),
        meta: { breadcrumb: "Treatment  Note" },
      },
      {
        path: "/settings/treatment-notes/create",
        name: "CreateTreatmentNoteView",
        component: () =>
          import("../views/Settings/TreatmentNote/AddTreatmentNote.vue"),
        meta: { breadcrumb: "Create Treatment Note" },
      },
      {
        path: "/settings/treatment-notes/:treatmentNoteId/edit",
        name: "EditTreatmentNoteView",
        props: true,
        component: () =>
          import("../views/Settings/TreatmentNote/EditTreatmentNote.vue"),
        meta: { breadcrumb: "Edit Treatment Note" },
      },
      {
        path: "/settings/treatment-notes/:treatmentNoteId/preview",
        name: "SettingsView",
        component: () =>
          import(
            "../views/Settings/TreatmentNote/ViewTemplateTreatmentNote.vue"
          ),
        meta: { breadcrumb: "Preview Treatment Note" },
      },
      {
        path: "/settings/users",
        name: "UsersView",
        component: () => import("../views/Settings/Users/UsersView.vue"),
        meta: { breadcrumb: "Users & practitioners" },
      },
      {
        path: "/settings/users/:id/edit",
        name: "EditUser",
        component: () => import("../views/Settings/Users/EditUser.vue"),
        props: true,
        meta: { breadcrumb: "Editing User" },
      },
      {
        path: "/settings/users/new",
        name: "AddUser",
        component: () => import("../views/Settings/Users/AddUser.vue"),
        meta: { breadcrumb: "New User" },
      },
      {
        path: "/settings/practitioners/:id/edit",
        name: "EditPractitioner",
        component: () => import("@/views/Settings/Users/EditDoctorSetting.vue"),
        props: true,
        meta: { breadcrumb: "Editing Practitioner" },
      },
      {
        path: "/settings/appointment-types",
        name: "AppointmentTypeServiceView",
        component: () =>
          import(
            "@/views/Settings/AppointmentTypeService/AppointmentTypeServiceView.vue"
          ),
        meta: { breadcrumb: "Appointment Type" },
      },
      {
        path: "/settings/appointment-types/new",
        name: "AddAppointmentTypeService",
        component: () =>
          import(
            "@/views/Settings/AppointmentTypeService/AddAppointmentTypeServiceView.vue"
          ),
        meta: { breadcrumb: "New Appointment Type" },
      },
      {
        path: "/settings/appointment-types/:id/edit",
        name: "EditAppointmentTypeService",
        component: () =>
          import(
            "@/views/Settings/AppointmentTypeService/EditAppointmentTypeService.vue"
          ),
        props: true,
        meta: { breadcrumb: "Editing Appointment Type" },
        beforeEnter: async (to, from, next) => {
          next();
        },
      },
      {
        path: "/settings/departments",
        name: "DepartmentView",
        component: () =>
          import("@/views/Settings/Department/DepartmentView.vue"),
        meta: { breadcrumb: "Departments" },
      },
      {
        path: "/settings/departments/new",
        name: "AddDepartment",
        component: () =>
          import("@/views/Settings/Department/AddDepartment.vue"),
        meta: { breadcrumb: "New Department" },
      },
      {
        path: "/settings/departments/:id/edit",
        name: "EditDepartment",
        component: () =>
          import("@/views/Settings/Department/EditDepartment.vue"),
        props: true,
        meta: { breadcrumb: "Editing Department" },
        beforeEnter: async (to, from, next) => {
          next();
        },
      },
      {
        path: "/settings/form-sign/add",
        name: "AddFormSign",
        component: AddFormSign,
        props: true,
        meta: { breadcrumb: "Add Form Sign" },
        beforeEnter: async (to, from, next) => {
          next();
        },
      },
      {
        path: "/settings/form-sign/:id",
        name: "EditFormSign",
        component: EditFormSign,
        props: true,
        beforeEnter: async (to, from, next) => {
          next();
        },
      },
      {
        path: "/settings/form-sign",
        name: "ViewFormSign",
        component: FormSignView,
        props: true,
        meta: { breadcrumb: "Form Sign" },
        beforeEnter: async (to, from, next) => {
          next();
        },
      },
      {
        path: "/settings/unavailable-block-types/create",
        name: "createUnavailableBlockTypes",
        component: AddUnavailableBlock,
        props: true,
        meta: { breadcrumb: "create Unavailable Block Types" },
      },

      {
        path: "/settings/unavailable-block-types/:id/edit",
        name: "EditUnavailableBlockTypes",
        component: EditUnavailableBlock,
        props: true,
        meta: { breadcrumb: "Edit Unavailable Block Types" },
      },
      {
        path: "/settings/unavailable-block-types",
        name: "ViewUnavailableBlockTypes",
        component: UnavailableBlockTypeView,
        props: true,
        meta: { breadcrumb: "Unavailable Block Types" },
      },
      {
        path: "/settings/programs/add",
        name: "AddProgram",
        component: AddProgram,
        props: true,
        meta: { breadcrumb: "Add Form Sign" },
        beforeEnter: async (to, from, next) => {
          next();
        },
      },
      {
        path: "/settings/programs/:id",
        name: "EditProgram",
        component: EditProgram,
        props: true,
        beforeEnter: async (to, from, next) => {
          next();
        },
      },
      {
        path: "/settings/programs",
        name: "ViewPrograms",
        component: ProgramView,
        props: true,
        meta: { breadcrumb: "Programs" },
        beforeEnter: async (to, from, next) => {
          next();
        },
      },
      {
        path: "/settings/packages",
        name: "ViewPackages",
        component: () => import("@/views/Settings/Package/PackageView.vue"),
        props: true,
        meta: { breadcrumb: "Packages" },
      },
      {
        path: "/settings/packages/add",
        name: "AddPackage",
        component: () => import("@/views/Settings/Package/AddPackage.vue"),
        props: true,
        meta: { breadcrumb: "Add Package" },
      },
      {
        path: "/settings/packages/:id/edit",
        name: "EditPackage",
        component: () => import("@/views/Settings/Package/EditPackage.vue"),
        props: true,
        meta: { breadcrumb: "Edit Package" },
      },
      {
        path: "/settings/service-types",
        name: "ViewServiceTypes",
        component: () => import("@/views/Settings/ServiceType/ServiceTypeView.vue"),
        props: true,
        meta: { breadcrumb: "Service Types" },
      },
      {
        path: "/settings/service-types/add",
        name: "AddServiceType",
        component: () => import("@/views/Settings/ServiceType/AddServiceType.vue"),
        props: true,
        meta: { breadcrumb: "Add Service Type" },
      },
      {
        path: "/settings/countries",
        name: "ViewCountries",
        component: () => import("@/views/Settings/Country/CountryView.vue"),
        props: true,
        meta: { breadcrumb: "Countries" },
      },
      {
        path: "/settings/countries/add",
        name: "AddCountry",
        component: () => import("@/views/Settings/Country/AddCountry.vue"),
        props: true,
        meta: { breadcrumb: "Add Country" },
      },
      {
        path: "/settings/countries/:id/edit",
        name: "EditCountry",
        component: () => import("@/views/Settings/Country/EditCountry.vue"),
        props: true,
        meta: { breadcrumb: "Edit Country" },
      },
      {
        path: "/settings/service-types/:id/edit",
        name: "EditServiceType",
        component: () => import("@/views/Settings/ServiceType/EditServiceType.vue"),
        props: true,
        meta: { breadcrumb: "Edit Service Type" },
      },
      {
        path: "/settings/insurances",
        name: "ViewInsurances",
        component: () => import("@/views/Settings/Insurance/InsuranceView.vue"),
        props: true,
        meta: { breadcrumb: "Insurances" },
      },
      {
        path: "/settings/insurances/add",
        name: "AddInsurance",
        component: () => import("@/views/Settings/Insurance/AddInsurance.vue"),
        props: true,
        meta: { breadcrumb: "Add Insurance" },
      },
      {
        path: "/settings/insurances/:id/edit",
        name: "EditInsurance",
        component: () => import("@/views/Settings/Insurance/EditInsurance.vue"),
        props: true,
        meta: { breadcrumb: "Edit Insurance" },
      },
      {
        path: "/settings/branches",
        name: "ViewBranches",
        component: () => import("@/views/Settings/Branch/BranchView.vue"),
        props: true,
        meta: { breadcrumb: "Branches" },
      },
      {
        path: "/settings/branches/add",
        name: "AddBranch",
        component: () => import("@/views/Settings/Branch/AddBranch.vue"),
        props: true,
        meta: { breadcrumb: "Add Branch" },
      },
      {
        path: "/settings/branches/:id/edit",
        name: "EditBranch",
        component: () => import("@/views/Settings/Branch/EditBranch.vue"),
        props: true,
        meta: { breadcrumb: "Edit Branch" },
      },
      {
        path: "/relatives",
        name: "RelativesView",
        component: () =>
          import("@/views/Settings/Relatives/RelativesView.vue"),
        meta: { breadcrumb: "Relatives Management", title: "Relatives" },
      },
      {
        path: "/requests",
        name: "PatientRequestsView",
        component: () =>
          import("@/views/Patients/requests/PatientRequestsView.vue"),
        meta: { breadcrumb: "Patient Requests", title: "Patient Requests" },
      },
      {
        path: "/settings/request-types",
        name: "ViewRequestTypes",
        component: () =>
          import("@/views/Settings/RequestType/RequestTypeView.vue"),
        props: true,
        meta: { breadcrumb: "Request Types" },
      },
      {
        path: "/settings/policies",
        name: "PatientPolicySettings",
        component: () =>
          import("@/views/Settings/Policy/PolicyManagementView.vue"),
        props: true,
        meta: { breadcrumb: "Patient Policies" },
      },
      {
        path: "/settings/request-types/add",
        name: "AddRequestType",
        component: () =>
          import("@/views/Settings/RequestType/AddRequestType.vue"),
        props: true,
        meta: { breadcrumb: "Add Request Type" },
      },
      {
        path: "/settings/request-types/:id/edit",
        name: "EditRequestType",
        component: () =>
          import("@/views/Settings/RequestType/EditRequestType.vue"),
        props: true,
        meta: { breadcrumb: "Edit Request Type" },
      },
    ],
  },
  {
    path: "/login",
    component: NoNavbar,
    children: [
      {
        path: "",
        name: "Login",
        component: () => import("../views/Login.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  await store.restored;
  const isAuthenticated = store.getters.isAuthenticated;
  if (to.name !== "Login" && !isAuthenticated) next({ name: "Login" });
  else {
    const requiredPermissions = to.meta?.requiredPermissions || [];
    const permissions = JSON.parse(localStorage.getItem("permissions") || "[]");
    const hasRequiredPermissions = requiredPermissions.every((permission) =>
      permissions.includes(permission)
    );
    if (requiredPermissions.length > 0 && !hasRequiredPermissions) {
      next({ path: "/" });
    } else next();
  }
});

// Global title management
router.afterEach((to, from) => {
  updateDocumentTitle(to);
});

// Global function to update document title
window.updateDocumentTitle = (route) => {
  // Set default title
  let title = "Maria Center";

  // Check if route has a custom title
  if (route.meta && route.meta.title) {
    title = `${route.meta.title} - Maria Center`;
  }

  // Check if route has a dynamic title function
  if (route.meta && route.meta.getTitle) {
    const dynamicTitle = route.meta.getTitle(route);
    if (dynamicTitle) {
      title = `${dynamicTitle} - Maria Center`;
    }
  }

  document.title = title;
};

export default router;
